import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import './index.css'
import Connect from "react-redux/es/connect/connect";
import {alertSuccess, getArticle, getPendingArticles, removeArticle} from "../../../actions";
import {
	dispatchOnApproveArticlesClickedArticleIdChanged,
	dispatchOnApproveArticlesGetArticles,
	dispatchOnApproveArticlesGetArticlesFailure,
	dispatchOnApproveArticlesGetArticlesSuccess,
	dispatchOnApproveArticlesRemoveArticles,
	dispatchOnApproveArticlesRemoveArticlesFailure,
	dispatchOnApproveArticlesRemoveArticlesSuccess,
	dispatchOnApproveArticlesRemoveModeChanged
} from './functions';
import Pagination from '../../subComponents/GenericPagination';
import Config from "../../../config";
import {debug, find, formatDateTimeUSToEU} from "../../../utility/functions";
import SuperModal from "../../subComponents/GenericModal/superModal";
import Loading from "../../subComponents/GenericLoading/loading";
import {
	dispatchOnCreateArticlesArticleToEditChanged,
	dispatchOnCreateArticlesSetArticleToEditChanged, getArticleMode
} from "../create/article/functions";
import NewsGalleryBlack from "../../../assets/news_gallery_black.png";
import NewsMultimediaBlack from "../../../assets/news_multimedia_black.png";
import BetterGenericTable from "../../subComponents/BetterGenericTable";
import {GET_SCHOOL_ARTICLES_PENDING} from "../../../api";

class ApproveArticles extends PureComponent {

	// Native component functions

	componentDidMount() {
		this._getPendingArticles();
	}

	// Custom component functions

	// Fetches all the pending articles from the api and dispatches functions to redux according to the result
	_getPendingArticles = (url) => {
		this.props.dispatchOnApproveArticlesGetArticles();
		getPendingArticles(url)
			.then((response) => {
				this.props.dispatchOnApproveArticlesGetArticlesSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnApproveArticlesGetArticlesFailure(error);
			});
	};

	onGetArticle = (id) => {
		getArticle(id)
			.then(response => {
				debug("article", response.data);
				this.props.dispatchOnCreateArticlesSetArticleToEditChanged(response.data);
				const articleType = getArticleMode(find(response.data, 'layout.path'));
				if (articleType === "gallery") {
					this.props.history.push('/create-news/gallery');
				} else {
					this.props.history.push('/create-news/multimedia');
				}
                this.props.dispatchOnApproveArticlesClickedArticleIdChanged(null);
			})
			.catch(error => {

			})
	};

	// This function attempts to remove an existing article with the data provided from the html page
	_removeArticle = (article, index) => {
		this.props.dispatchOnApproveArticlesRemoveArticles();
		removeArticle(article)
			.then(response => {
				alertSuccess(response.message);
				this.props.dispatchOnApproveArticlesRemoveArticlesSuccess(article, index, response);
			})
			.catch((error) => {
				this.props.dispatchOnApproveArticlesRemoveArticlesFailure(error);
			})
	};

	// This function is called when the 'pencil' icon is clicked in an article row
	// Calls the Create articles page and edits its html layout to edit the selected article
	onEditPressed = (article) => {
		const id = find(article, 'id');
		this.props.dispatchOnApproveArticlesClickedArticleIdChanged(id);
		this.onGetArticle(id);
	};

	// This function is called when the 'trash' icon is clicked in an article row
	// It is responsible for making a modal render with functions to remove the selected article
	onRemovePressed = (article, index) => {
		this.props.dispatchOnApproveArticlesRemoveModeChanged(article, index, true)
	};

	// Native component render function

	render() {
		const {t} = this.props;
		return (
			<div>
				<div>
					<div className="container-news-approve-header">
						<div className="container-header-tittle"><h2>{t('News')}</h2></div>
						<div className='container-header-arrow'>{">"}</div>
						<div className="container-header-subtittle">{t('Approve News')}</div>
					</div>
					<div>
						<BetterGenericTable
							data={this.props.articles}
							columns={[
								{
									rowComponent: (row, index) => {
										const images = find(row, 'images');
										return (
											<img
												style={{height: 24}}
												src={images.length > 1 ? NewsGalleryBlack : NewsMultimediaBlack}
												alt={""}
											/>
										)
									}
								},
								{
									name: t("Title"),
									value: (item, index) => {
										return find(item, 'title');
									},
									rowClassName: 'table-column-list-articles-title'
								},

								{
									name: t("Class"),
									value: (item, index) => {
										return find(item, 'user_name');
									},
								},
								{
									name: t("Submission"),
									value: (item, index) => formatDateTimeUSToEU(find(item, 'publishedDate'))
								},
								{
									name: t("Actions"),
									rowComponent: (row, index) => (
										(
											<div className="container-news-manage-table-row-icons">
												<img className="container-news-manage-table-row-edit-icon"
												     src={"../../../assets/edit.png"}
												     alt={""} onClick={() => this.onEditPressed(row, index)}/>
												<img className="container-news-manage-table-row-edit-icon"
												     src={"../../../assets/trash.png"}
												     alt={""} onClick={() => this.onRemovePressed(row, index)}/>
											</div>
										)
									)
								}
							]}
							loading={this.props.loading}
							loadingComponent={(
								<Loading size={"small-spinner"} color={"blue"}/>
							)}
							emptyTableComponent={t("No articles pending")}
							rowLoading={(row, index) => {
								return find(row, 'id') === this.props.clickedArticleId;
							}}
							rowLoadingComponent={(
								<div className={'container-dashboard-body-table-row-loading-component'}>
									<Loading size={"small-spinner"} color={"blue"}/>
									<div style={{marginLeft: 8}}>Carregando Artigo</div>
								</div>
							)}
						/>
						{this.renderPaginationButtons()}
					</div>
				</div>
				{this.renderRemoveModal()}
			</div>
		);
	}

	// Custom component render functions

	renderPaginationButtons() {
		if (!this.props.pagination) return;
		const {current_page, last_page} = this.props.pagination;
		return (
			<Pagination
				totalPages={last_page}
				currentPage={current_page}
				baseUrl={Config.urlApi + GET_SCHOOL_ARTICLES_PENDING}
				onPageChanged={(url) => {
					this._getPendingArticles(url)
				}}
			/>
		)
	}

	renderRemoveModal() {
		const {t, inRemoveMode, removing, article, index} = this.props;
		if (inRemoveMode) {
			return (
				<SuperModal
					onOkPressed={() => {
						this._removeArticle(article, index)
					}}
					onCancelPressed={() => {
						this.props.dispatchOnApproveArticlesRemoveModeChanged(null, null, false)
					}}
					onCloseModal={() => {
						this.props.dispatchOnApproveArticlesRemoveModeChanged(null, null, false)
					}}
					okButtonVariant={"danger"}
					okButtonText={t('Remove')}
					cancelButtonText={t('Cancel')}
					title={t("Do you wish to remove this article?")}
					okLoading={removing}
				>
					<text>{find(article, 'title') || ""}</text>
				</SuperModal>
			)
		}
	}
}

const mapStateToProps = store => ({
	loading: store.approveArticlesReducer.loading,
	articles: store.approveArticlesReducer.articles,
	article: store.approveArticlesReducer.article,
	index: store.approveArticlesReducer.index,
	inRemoveMode: store.approveArticlesReducer.inRemoveMode,
	removing: store.approveArticlesReducer.removing,
	pagination: store.approveArticlesReducer.pagination,
	clickedArticleId: store.approveArticlesReducer.clickedArticleId,
});

const mapFunctionsToProps = {
	dispatchOnApproveArticlesGetArticles,
	dispatchOnApproveArticlesGetArticlesSuccess,
	dispatchOnApproveArticlesGetArticlesFailure,
	dispatchOnApproveArticlesRemoveArticles,
	dispatchOnApproveArticlesRemoveArticlesSuccess,
	dispatchOnApproveArticlesRemoveArticlesFailure,
	dispatchOnApproveArticlesRemoveModeChanged,
	dispatchOnCreateArticlesArticleToEditChanged,
	dispatchOnCreateArticlesSetArticleToEditChanged,
	dispatchOnApproveArticlesClickedArticleIdChanged
};

export default (Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(ApproveArticles)));
